import { themes } from '../bff.api';
import responseValidators from '../response.validators';

const _handleError = (err, onError) => {
  if (onError) {
    onError(err.message);
  }
};

const _apiBody = (data) => ({
  name: data?.name
});

const getAll = async (options = {}) => {
  return themes
    .getAll()
    .then((resp) => {
      responseValidators.getAllThemes(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const add = async (data, options = {}) => {
  return themes
    .add(_apiBody(data))
    .then((resp) => {
      responseValidators.addTheme(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const update = async (id, data, options = {}) => {
  return themes
    .update(id, _apiBody(data))
    .then((resp) => {
      responseValidators.updateTheme(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const remove = async (id, options = {}) => {
  return themes
    .remove(id)
    .then((resp) => {
      responseValidators.removeTheme(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const themesService = { getAll, add, update, remove };

export default themesService;
